var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"phone android"},[_c('div',{ref:"content",staticClass:"phone-con"},[_c('div',{staticClass:"fpe-root",attrs:{"lang":"pt-br","dir":"ltr","role":"textbox"},domProps:{"innerHTML":_vm._s(_vm.strHtml)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }